import { render, staticRenderFns } from "./menzhen-edit.vue?vue&type=template&id=072006e4&"
import script from "./menzhen-edit.vue?vue&type=script&lang=ts&"
export * from "./menzhen-edit.vue?vue&type=script&lang=ts&"
import style0 from "./menzhen-edit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports